<basetile-renderer #mdBusinessUnitTileRenderer>
  <div target="title">
    <wiz-label [wizLabel]="data.name" [wizTextBehavior]="'truncate'"></wiz-label>
  </div>
  <div target="body">
    <wiz-vgroup width="100%" height="100%">

      <wiz-hgroup width="100%" height="100%" [verticalAlign]="'center'" [horizontalAlign]="'center'">
        <wiz-image width="50px" height="50px" [sourceObservable]="data.iconOrDie" style="align-self: center"></wiz-image>
      </wiz-hgroup>
    </wiz-vgroup>
  </div>
</basetile-renderer>
